export class StateListWidget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<StateListItem>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StateListWidget.attributeTypeMap;
    }
    constructor() {
    }
}
